import React = require('react');

import SvgIcon from '@material-ui/core/SvgIcon';

export interface IIconProps {
  style?: any;
  color?: string;
  disabled?: boolean;
  viewBox?: string;
  className?: string;
  onClick?: () => any;
}

interface IIconOwnProps extends IIconProps {
  svg: React.Component | React.ReactNode;
}

export default class Icon extends React.Component<IIconOwnProps> {
  public render() {
    const { color, style, disabled, svg, ...rest } = this.props;

    return (
      <SvgIcon
        style={{
          ...(style || {}),
          color: disabled ? 'inherit' : color,
        }}
        {...rest}
      >
        {svg}
      </SvgIcon>
    );
  }
}
